import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { Box, useMediaQuery } from "@mui/material";

export default function TimerCountDown({ countDownDate }) {
  const matches = useMediaQuery("(max-width:700px)");

  let interval = useRef();
  const [countTime, setCountDateTime] = useState({
    time_days: 0,
    time_Hours: 0,
    time_Minusts: 0,
    time_seconds: 0,
  });

  const startTime = async () => {
    let interval = setInterval(() => {
      let now = moment().format("X");
      const distance = +countDownDate - +now;

      const days = Math.floor(distance / (60 * 60 * 24));
      const hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
      const minuts = Math.floor((distance % (60 * 60)) / 60);
      if (distance < 0) {
        clearInterval(interval.current);
      } else {
        setCountDateTime({
          ...countTime,
          time_days: days,
          time_Hours: hours,
          time_Minusts: minuts,
        });
      }
    }, 1000);
  };
  useEffect(() => {
    startTime();
  }, []);
  return (
    <Box
      mt={3}
      borderRadius="0px"
      fontSize={matches ? "12px" : "15px"}
      fontWeight="500"
      mb={3}
    >
      {countTime.time_days}d : {countTime.time_Hours}h :{" "}
      {countTime.time_Minusts}m
    </Box>
  );
}
